<template>
  <div class="addDisposition">
    <div class="newsDetial-header" v-if="id">
      <div v-if="tabnum == 1">
        <div class="newsDetial-title">固定资产处置申请单</div>
        <blank height="7"> </blank>
        <div class="card-title">
          <div class="state1" v-if="resData.state == 1">审批中</div>
          <div class="state2" v-if="resData.state == 2">已归档</div>
          <div class="state3" v-if="resData.state == 3">退回</div>
          <div class="state4" v-if="resData.state == 4">取消</div>
        </div>
      </div>
      <div v-else>
        <div class="newsDetial-title">固定资产处置审批流程</div>
        <blank height="7"> </blank>
        <a-button
          v-if="resData.state == 2"
          class="detial-top-btn"
          type="primary"
          icon="printer"
          @click="printDDD()"
        >
          打印
        </a-button>
      </div>
      <a-tabs v-model="tabnum" @change="tabClick">
        <a-tab-pane key="1" tab="表单详情" />
        <a-tab-pane key="2" tab="表单流程" v-if="resData.state > 0" />
      </a-tabs>
    </div>
    <div class="newsDetial-header" v-else>
      <div class="newsDetial-title">新建表单</div>
      <blank height="15"> </blank>
      <div class="newsDetial-abstract">
        请按照要求填写相关信息，并提交进行流程审批
      </div>
      <blank height="45"> </blank>
    </div>
    <div class="detial-cont" v-if="tabnum == 1">
      <disposition-detail-form
        :disabled="disabled"
        :resData="resData"
      ></disposition-detail-form>
    </div>
    <div class="detial-cont" v-if="tabnum == 1">
      <!-- 固定资产附件 -->
      <accessories-table
        v-model="updateList"
        :file="updateList"
        :disabled="disabled"
      ></accessories-table>
    </div>
    <div class="detial-cont" v-if="tabnum == 2">
      <div class="detial-cont-title">审批流程图示</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <!-- 审批流 表单流程 -->
        <keep-alive>
          <approvalChart
            ref="refChart"
            :approvalChartData="approvalChartData"
          ></approvalChart>
        </keep-alive>
      </div>
    </div>
    <appfloor v-if="tabnum == 2"></appfloor>
    <template v-if="tabnum == 1">
      <bottomSuspension>
        <a-button :style="{ marginRight: '20px' }" @click="goback">
          返回
        </a-button>
        <!-- 表单为可编辑状态 显示提交按钮 -->
        <template>
          <div v-if="proQueryParams.isEdit === '0' ? true : false">
            <a-button
              :loading="confirmLoading && resData.draft == 2"
              type="primary"
              class="orange-btn"
              @click="preserveFn('0')"
              :style="{ marginRight: '20px' }"
            >
              保存
            </a-button>
          </div>
          <a-button
            v-if="!resData.state && !disabled"
            :loading="confirmLoading && resData.draft == 1"
            type="primary"
            class="orange-btn"
            @click="preserveFn('1')"
            :style="{ marginRight: '20px' }"
          >
            保存
          </a-button>
          <a-button
            v-if="!resData.state && !disabled"
            :loading="loading && resData.draft == 2"
            type="primary"
            :style="{ marginRight: '20px' }"
            @click="submitFn"
          >
            提交
          </a-button>
          <a-button
            v-if="proQueryParams.showApproveBtn === '1'"
            :loading="loading && resData.draft == 2"
            type="primary"
            :style="{ marginRight: '20px' }"
            @click="submitFn"
          >
            {{ resData.state === 3 ? '提交' : '审批' }}
          </a-button>
        </template>
        <div v-if="proQueryParams.showApproveBtn === '1' ? true : false">
          <a-button
            v-if="resData.state === 3 ? true : false"
            type="danger"
            @click="cancelPro('2')"
            :style="{ marginRight: '20px' }"
          >
            删除
          </a-button>
          <!-- <a-button
            v-if="resData.state === 3 ? true : false"
            type="primary"
            @click="cancelPro('1')"
            :style="{ marginRight: '20px' }"
          >
            提交
          </a-button>
          <a-button
            v-if="resData.state === 3 ? false : true"
            @click="approvalPro"
            type="primary"
            :style="{ marginRight: '42px' }"
          >
            审批
          </a-button> -->
        </div>
      </bottomSuspension>
    </template>
    <!-- 审批流审批弹窗 -->
    <approvalSubmission v-model="isActivitiMode"></approvalSubmission>

    <print
      v-model="isPrint"
      v-if="resData.state == 2"
      :id="id"
      mobilePath="/pages/workbench/fixedAssets/disposalApply/details?id="
      skipPageReqFlag="/disDetial"
    >
      <div class="print-title">北京民政工业总公司固定资产处置审批表</div>
      <div class="printd-cont">
        <div class="printd-cont-title">
          <span>日期：{{ getday() }}</span>
          <span>单位：元</span>
        </div>
        <div class="printd-item">
          <a-descriptions bordered size="small">
            <a-descriptions-item label="处置单位" :span="1.5">
              {{ resData.organizationName }}
            </a-descriptions-item>
            <a-descriptions-item label="资产名称" :span="1.5">
              {{ resData.assetsname }}
            </a-descriptions-item>
            <a-descriptions-item label="账面原值" :span="1.5">
              {{ resData.storage }}
            </a-descriptions-item>
            <a-descriptions-item label="购建时间" :span="1.5">
              {{ resData.buildtime }}
            </a-descriptions-item>
            <a-descriptions-item label="规格型号" :span="1.5">
              {{ resData.model }}
            </a-descriptions-item>
            <a-descriptions-item label="已提折旧" :span="1.5">
              {{ resData.depreciation }}
            </a-descriptions-item>
            <a-descriptions-item label="计划使用年限" :span="1.5">
              {{ resData.plannedlife }}
            </a-descriptions-item>
            <a-descriptions-item label="单价" :span="1.5">
              {{ resData.unitprice }}
            </a-descriptions-item>
            <a-descriptions-item label="净值" :span="1.5">
              {{ resData.networth }}
            </a-descriptions-item>
            <a-descriptions-item label="已使用年限" :span="1.5">
              {{ resData.usefullife }}
            </a-descriptions-item>
            <a-descriptions-item label="数量" :span="1.5">
              {{ resData.count }}
            </a-descriptions-item>
            <a-descriptions-item label="预计残值" :span="1.5">
              {{ resData.amount }}
            </a-descriptions-item>
            <a-descriptions-item label="处置形式" :span="1.5">
              {{ getByTypeName(resData.disposalstate, dasset_typeList) }}
            </a-descriptions-item>
            <a-descriptions-item label="备注" :span="1.5">
              {{ resData.cause }}
            </a-descriptions-item>
            <a-descriptions-item label="处置原因" :span="3">
              {{ resData.reason }}
            </a-descriptions-item>
          </a-descriptions>
        </div>
        <div class="printd-item">
          <a-table
            size="small"
            :pagination="false"
            :columns="columns"
            :data-source="formDTOList"
            :row-key="(record) => record.id"
            bordered
          >
          </a-table>
        </div>
      </div>
    </print>
  </div>
</template>

<script>
import {
  saveDisposition,
  getDispositionDetail,
  updateDisposition
} from './api/api'
import ApprovalTrack from './components/approvalTrack.vue'
import AccessoriesTable from '@/components/accessories-table/index.vue'
import dispositionDetailForm from './components/dispositionDetailForm.vue'
import approvalSubmission from '@/components/approval-submission/index'
import approvalChart from '@/components/approval-chart/index'
import { formatDateNoDetails } from '@/assets/js/auth'
import { mapState, mapActions } from 'vuex'
import { activitiSubmission } from '@/utils/utils'
export default {
  components: {
    AccessoriesTable,
    ApprovalTrack,
    dispositionDetailForm,
    approvalSubmission,
    approvalChart
  },
  data() {
    return {
      confirmLoading: false,
      loading: false,
      isPrint: false, // 打印弹窗
      tabnum: '1',
      id: '',
      resData: {},
      updateList: null,
      // 审批流部分
      // disabled: true,
      isActivitiMode: {
        isActivitiShow: false,
        proQueryParams: []
      },
      proQueryParams: [],
      // 审批流部分
      columns: [
        {
          title: '审批部门（人）',
          dataIndex: 'dutyOfficerStr',
          key: 'dutyOfficerStr',
          align: 'left'
        },
        {
          title: '审批意见',
          dataIndex: 'fieldValue1',
          key: 'fieldValue1',
          align: 'left'
        },
        {
          title: '审批时间',
          dataIndex: 'createTime',
          key: 'createTime',
          align: 'left'
        }
      ],
      formDTOList: [],
      pIsedit: ''
    }
  },
  computed: {
    ...mapState({
      organizationUserList: (state) => state.app.organizationUserList, // 当前用户可选部门
      dasset_typeList: (state) => state.bytype.dasset_typeList
    }),
    // 获取表单是否可编辑状态  false可编辑  true不可编辑
    disabled: function () {
      if (!this.id) {
        // id不存在  为添加  可编辑
        return false
      } else {
        this.proQueryParams = this.$route.query
        if (this.proQueryParams.isEdit) {
          if (
            this.proQueryParams.isEdit === '100' ||
            this.proQueryParams.isEdit === '1'
          ) {
            return true
          } else {
            return false
          }
        } else if (this.resData.state == 1 || this.resData.state == 2) {
          //审批状态和归档状态  不可编辑
          return true
        } else {
          // 草稿箱或退回状态  可编辑
          return false
        }
      }
    }
  },
  created() {
    this.id = this.$route.query.id ? this.$route.query.id : ''
    // 获取处置类型字典表
    this.getdasset_type()
    if (this.id) {
      this.getDispositionDetailFn()
    } else {
      let date = new Date()
      this.$set(this.resData, 'buildtime', formatDateNoDetails(date))
      this.$set(
        this.resData,
        'organizationId',
        this.$store.state.app.organizationId
      )
    }
  },
  watch: {
    updateList(val) {
      // 附件上传成功 刷新列表
    }
  },
  methods: {
    ...mapActions(['getdasset_type']),
    //通过字典值过去字典名
    getByTypeName(value, list) {
      let byType = list.find((item) => {
        return item.valuename == value
      })
      if (byType) {
        return byType.keyname
      } else {
        return value
      }
    },
    getday() {
      let date = new Date()
      return formatDateNoDetails(date)
    },
    printDDD() {
      this.formDTOList = this.$refs.refChart.getHighLine.formDTOList
      this.isPrint = true
      document.title =
        '固定资产处置-' +
        this.resData.assetsname +
        this.$printFormatDate(new Date())
    },
    // 审批流取消
    cancelPro(key) {
      switch (key) {
        case '1':
          // 提交
          this.$confirm({
            title: '您是否提交?',
            onOk: () => {
              activitiSubmission(this.proQueryParams, '1', this)
            },
            onCancel: () => {
              console.log('Cancel')
            }
          })
          break
        case '2':
          // 取消
          this.$confirm({
            title: '您是否删除?',
            onOk: () => {
              activitiSubmission(this.proQueryParams, '2', this)
            },
            onCancel: () => {
              console.log('Cancel')
            }
          })
          break

        default:
          break
      }
    },
    // 切换审批流 表单流程
    tabClick(key) {
      if (key == 2) {
        this.approvalChartData = this.proQueryParams
      } else {
        this.getDispositionDetailFn()
      }
    },
    // 固定资产 申请模块 工作流审批
    approvalPro() {
      this.isActivitiMode = {
        isActivitiShow: true,
        proQueryParams: this.proQueryParams
      }
    },
    goback() {
      this.$router.push('/disposition')
    },
    // 提交
    submitFn() {
      this.resData.draft = 2
      this.saveDispositionFn('新建')
    },
    // 保存
    preserveFn(type) {
      if (type === '0') {
        // 自定义保存判断 1 = 仅保存
        this.pIsedit = '1'
        this.resData.draft = 2
      } else {
        this.pIsedit = '2'
        this.resData.draft = 1
      }
      this.saveDispositionFn('保存')
    },
    saveDispositionFn(type) {
      if (!this.resData.organizationId) {
        this.$message.error('请添加部门')
        return false
      }
      if (!this.resData.assetsname) {
        this.$message.error('请输入资产名称')
        return false
      }
      if (!this.resData.storage) {
        this.$message.error('请输入账面原值')
        return false
      }
      if (!this.resData.amount) {
        this.$message.error('请输入预计残值')
        return false
      }
      if (!this.resData.disposalstate) {
        this.$message.error('请选择处置形式')
        return false
      }
      this.confirmLoading = true
      this.resData.dfile = this.updateList
      this.resData.appId = this.$route.meta.appId
      this.resData.skipPageReqFlag = '/disDetial'
      if (this.pIsedit === '') {
        this.loading = true
      } else {
        this.confirmLoading = true
      }
      if (this.id) {
        //修改
        updateDisposition(this.resData).then((res) => {
          if (res.data.code == 0) {
            if (this.pIsedit === '1') {
              this.$message.success('保存成功')
              this.pIsedit = ''
            } else {
              if (this.resData.state > 0) {
                this.getDispositionDetailFn()
                // 合并 保存+审批流操作
                if (
                  this.proQueryParams.showApproveBtn === '1' &&
                  this.resData.state != '3'
                ) {
                  this.approvalPro()
                } else {
                  this.cancelPro('1')
                }
                // this.$message.success('修改成功')
                // 合并 保存+审批流操作
              } else {
                if (this.resData.draft == 2) {
                  this.$message.success('提交成功')
                  this.goback()
                } else {
                  this.$message.success('保存成功')
                }
              }
            }
            this.loading = false
            this.confirmLoading = false
          } else {
            this.loading = false
            this.confirmLoading = false
          }
        })
      } else {
        //获取部门名称
        let organizationName = ''
        this.organizationUserList.forEach((item, index) => {
          if (item.organizationId == this.resData.organizationId) {
            organizationName = item.organizationname
          }
        })
        this.resData.organizationName = organizationName
        saveDisposition(this.resData).then((res) => {
          if (res.data.code == 0) {
            this.$message.success(type + '成功')
            if (this.resData.draft == 2) {
              this.goback()
            } else {
              //首次添加
              this.id = res.data.data
              this.getDispositionDetailFn()
            }
            this.loading = false
            this.confirmLoading = false
          } else {
            this.loading = false
            this.confirmLoading = false
          }
        })
      }
    },
    // 获取详情
    getDispositionDetailFn() {
      const params = {
        id: this.id
      }
      getDispositionDetail(params).then((res) => {
        if (res.data.code == 0) {
          this.resData = res.data.data
          this.updateList = this.resData.dfile
          // 多个对象合并合并多个
          let processInstanceId = {
            processInstanceId: res.data.data.processInstanceId,
            detailsData: res.data.data
          }
          Object.assign(this.proQueryParams, processInstanceId)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.addDisposition {
  .newsDetial-header {
    position: relative;
    background: #fff;
    padding: 0 40px;
    .newsDetial-title {
      height: 26px;
      color: rgba(56, 56, 56, 1);
      font-size: 18px;
      line-height: 26px;
      font-weight: bold;
    }
    .newsDetial-abstract {
      color: rgba(166, 166, 166, 1);
      font-size: 14px;
      line-height: 22px;
    }
    .detial-top-btn {
      position: absolute;
      right: 87px;
      top: 0;
    }
  }
  .detial-cont {
    margin: 24px 16px;
    .detial-cont-title {
      background: #fff;
      height: 55px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      line-height: 55px;
      text-align: left;
      padding-left: 32px;
    }
    .detial-cont-view {
      background: #fff;
      padding: 30px;
      .accessory-btn {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}

// 打印内容不能嵌套写样式

.print-title {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  height: 50px;
  line-height: 50px;
}
.printd-cont-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  // border: 1px solid #cecece;
  border: 1px solid #333333;
  border-bottom: none;
  padding: 0 15px;
  color: #000000;
}
</style>

<style scoped src="@/assets/css/printModal.css"></style>



// WEBPACK FOOTER //
// src/views/FixedAssets/disDetial.vue